import {NoteLinkedGroupKind, NoteLinkedGroup} from 'notebook/notes/groups/NoteLinkedGroupConstants';
import {
  FromServerNoteLinkedFile,
  NoteLinkedObject,
  NoteLinkedObjectType,
  NotePart,
} from 'notebook/util/NoteUtilConstants';

export const MIN_ITEM_WIDTH = 150;
export const MAX_ITEM_WIDTH = 400;

// Horizontal chrome around grid-contained images: 2 * (1px border + 4px padding) = 10px.
export const GRID_CONTAINED_IMAGE_PADDING = 10;

export interface NotePartGridGroupMetadata {}

export interface GridImageTask {
  taskId: string;
  fileUploadDeferred: JQueryPromise<FromServerNoteLinkedFile>;
  fileName?: string;
}

export interface CreateNotePartGridGroupExtras {
  gridImageTasks?: Array<GridImageTask>;
}

export interface GridPlaceholderNotePart extends NotePart {
  _fileUploadDeferred?: JQueryPromise<FromServerNoteLinkedFile>;
  _fileName?: string;
}

export type NotePartGrid = NoteLinkedGroup<NotePartGridGroupMetadata>;

export function isNotePartGrid(noteLinkedObject: NoteLinkedObject): noteLinkedObject is NotePartGrid {
  return (
    noteLinkedObject.type === NoteLinkedObjectType.NOTE_LINKED_GROUP &&
    noteLinkedObject.kind === NoteLinkedGroupKind.NOTE_PART_GRID
  );
}
